// core
import {Component, Input, ElementRef} from '@angular/core';

// ngx-bootstrap
import {BsModalService} from 'ngx-bootstrap/modal';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';

// service
import {DataService} from '../service/data.service';
import {JsPlumbService} from '../service/jsPlumb.service';

// component
// import { ModalModelComponent } from '../modal-model/modal-model.component';
// import { ModalSchemaComponent } from '../modal-schema/modal-schema.component';

// class
import {Model} from '../class/model';
import {Schema} from '../class/schema';

@Component({
    selector: 'model',
    templateUrl: './model.component.html',
    styleUrls: ['./model.component.css']
})
export class ModelComponent {

    @Input() myModel: Model;

    private bsModalRef: BsModalRef;

    constructor(private bsModalService: BsModalService, private dataService: DataService, private jsPlumbService: JsPlumbService, private el: ElementRef) {
    }

    ngAfterViewInit() {
        this.jsPlumbService.initModel(this.myModel);
        this.myModel.schema_id_for_relation = Number(this.myModel.schema_id_for_relation);
        this.dataService.flg_repaint = true;
        this.jsPlumbService.repaintEverything();
    }

    ngOnDestroy() {
        //this.jsPlumbService.destroyModel(this.myModel);
    }

    private editModel(): void {
        // this.bsModalRef = this.bsModalService.show( ModalModelComponent, {initialState:{
        //   mode: 'edit',
        //   model: this.myModel,
        //   use_laravel_auth: this.dataService.data.use_laravel_auth
        // }});
    }

    private deleteModel() {
        if (confirm('Want to delete ' + this.myModel.name + '?')) {
            this.dataService.deleteModel(this.myModel.id);
        }
    }

    private addSchema(): void {
        var schema = new Schema();
        schema.parent_id = this.myModel.id;
        if (this.dataService.data.use_laravel_auth) {
            schema.nullable = true;
        }
        // this.bsModalRef = this.bsModalService.show( ModalSchemaComponent, {initialState:{
        //   mode: 'create',
        //   schema: schema,
        //   use_laravel_auth: this.dataService.data.use_laravel_auth,
        //   parent_model: this.myModel
        // }} );
    }

    public startDrag(): void {
        this.jsPlumbService.toggleDraggable(this.myModel);
    }

    public endDrag(): void {
        this.jsPlumbService.toggleDraggable(this.myModel);

        // record position
        let style_left = this.el.nativeElement.querySelectorAll('#' + this.myModel.getElementId())[0].style.left;
        let style_top = this.el.nativeElement.querySelectorAll('#' + this.myModel.getElementId())[0].style.top;
        this.myModel.pos_x = parseInt(style_left, 10);
        this.myModel.pos_y = parseInt(style_top, 10);
    }
}
